<template>
  <div class="loading">
    <h4 class="text-muted">{{text}}</h4>
  </div>
</template>

<script>

  export default {
    name: "Spinner",
    props: {
      text: {type: String, default: "Cargando..."},
    }
  }
</script>

<style scoped>
  .loading {
    text-align: center;
    animation: fadeInOut linear infinite 200ms;
  }

  @keyframes fadeInOut {
    to {
      opacity: 1;
    }
    from {
      opacity: 0;
    }
  }
</style>
